// extracted by mini-css-extract-plugin
export default {"creatable-cell":"kgMmV9aB9tHFp2Y61RVO","creatable-text":"LkBee5IAOLWKzHdn4DNQ"};